import { Outlet, Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AuthVerify from "./authVerify";

// "/sign-in?redirectTo=<path+query without the leading slash>"; no redirectTo
// at all for "/", where there is nothing to come back to.
export const signInPathFor = (location, base = "/sign-in") => {
  const back = `${location.pathname.substring(1)}${location.search}`;
  return back ? `${base}?redirectTo=${encodeURIComponent(back)}` : base;
};

// Catch-all route. Signed-out visitors don't get the role-based routes
// registered, so a deep link (e.g. /procurement/order-requests/12) lands here
// before AuthWrapper ever sees it; keep that path instead of falling through
// to "/" and signing in with an empty redirectTo.
export const FallbackRedirect = ({ isAuthenticated, defaultRoute }) => {
  const location = useLocation();
  return <Navigate to={isAuthenticated ? defaultRoute : signInPathFor(location)} replace={!isAuthenticated} />;
};

FallbackRedirect.propTypes = {
  isAuthenticated: PropTypes.bool,
  defaultRoute: PropTypes.string,
};

export const AuthWrapper = ({ isAllowed, redirectPath = "/sign-in", children }) => {
  const location = useLocation();

  if (!isAllowed) {
    // Deep links (e.g. approval emails) must land back on the same page after login.
    const target = redirectPath.includes("?") ? redirectPath : signInPathFor(location, redirectPath);
    return <Navigate to={target} replace state={{ from: location }} />;
  }

  return (
    <>
      {children ? children : <Outlet />}
      <AuthVerify />
    </>
  );
};

AuthWrapper.propTypes = {
  isAllowed: PropTypes.bool,
  redirectPath: PropTypes.string,
  children: PropTypes.node,
};
